import React from 'react';
import css from './Edit.module.css';
import { MdOutlineDashboardCustomize } from "react-icons/md";
import { motion } from "framer-motion";

const Edit=({view, setView})=>{
    return (
        <motion.div
            className={css.box}
            whileHover={{ scale: 1.1 }} // Slightly enlarges on hover
            whileTap={{ scale: 0.9 }} // Shrinks slightly when clicked
            transition={{ type: "spring", stiffness: 300 }}
        >
            <div className={view !== 'edit' ? `${css.box} ${css.inActive}` : `${css.box} ${css.active}`} onClick={() => setView('edit')}>
            
                <div className={css.iconWrapper}>
                    
                        <MdOutlineDashboardCustomize className={css.icon} />
                    
                </div>
                <div className={css.label}>
                    Edit
                </div>
            
            </div>
         </motion.div>
    );  
}
export default Edit;